import { useEffect, useState } from 'react'
import fetch from 'utils/fetch'
import showAlert from 'utils/showAlert'
import { cgiCallWrapper } from 'utils/cgiCallWrapper'
import { LOGIN_URL } from '../../constants'

export const getUserInfoFetch = params => {
    return fetch({
        url: '/user/identity',
        data: params,
    })
}

const useUserInfo = () => {
    const [userInfo, setUserInfo] = useState({})
    useEffect(() => {
        const getUserInfoCall = async () => {
            const getUserInfo = async () => {
                const res = await cgiCallWrapper(getUserInfoFetch)
                if (res.b) {
                    setUserInfo(res.b || {})
                } else {
                    throw new Error(res.d)
                }
            }
            try {
                await getUserInfo()
            } catch (e) {
                showAlert(e.message || '未知错误')
            }
        }
        getUserInfoCall()
    }, [setUserInfo])
    const signOut = () => {
        document.cookie = 'client_id=;expires=Mon, 26 Jul 1997 05:00:00 GMT; path=/; domain=.qq.com;'
        window.location.href = LOGIN_URL
    }
    return { userInfo, signOut }
}

export default useUserInfo
